import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
export function BlogPage() {
  return <div className="min-h-screen bg-weiss flex flex-col" data-id="element-224">
      <Navigation data-id="element-225" />
      <main className="flex-grow flex items-center justify-center pt-32 pb-16" data-id="element-226">
        <h1 className="text-5xl md:text-7xl font-heading text-schwarz" data-id="element-227">Blog</h1>
      </main>
      <Footer data-id="element-228" />
    </div>;
}